import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'data-table-button-container',
  templateUrl: './data-table-button-container.component.html',
  styleUrls: ['./data-table-button-container.component.scss']
})
export class DataTableButtonContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
